import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Pipe, PipeTransform, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbAccordion, NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BehaviorSubject, debounceTime, pipe, Subject, tap } from 'rxjs';
import { CandidateFilterTemplateComponent } from 'src/app/components/candidate-module/candidate-filter-template/candidate-filter-template.component';
import { CandidateVerticalFilterTemplateComponent } from 'src/app/components/candidate-module/candidate-vertical-filter-template/candidate-vertical-filter-template.component';
import { JobFilterTemplateComponent } from 'src/app/components/job-module/job-filter-template/job-filter-template.component';
import { JobFilterVerticalTemplateComponent } from 'src/app/components/job-module/job-filter-vertical-template/job-filter-vertical-template.component';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from 'src/app/icons/icon-provider';

@Pipe({
  name: 'filterData',
  standalone: true
})
export class FilterDataPipe implements PipeTransform{

  transform(items: any, arg : any , val : any): any {
      if(items.length > 0){
        return items.filter(x => (x[arg])!.toLowerCase().includes(val.toLowerCase()));
      }
  }

}


@Component({
  selector: 'app-customer-filter-template',
  standalone: true,
  imports: [CommonModule, FilterDataPipe, NgbAccordionModule, FormsModule, InfiniteScrollModule,

    NgIconComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // Provide the project's icon set so <ng-icon name="tablerLoader2">
  // (used inside the picker's inline spinner) resolves to a real glyph.
  // Without provideIcons the icon would render as an empty box.
  providers: [provideIcons(APP_ICONS)],
  templateUrl: './customer-filter-template.component.html',
  styleUrls: ['./customer-filter-template.component.scss']
})
export class CustomerFilterTemplateComponent implements OnInit, OnDestroy , OnChanges {

  @Input() title : string = 'Customer';
  @Input() ID : string ;
  @Input() panelName : string = "";
  @Input() searchResult : Array<string> = [];
  @Input() showFilter : boolean = true;
  @Input() withAccordion : boolean = true;
  @Input() resetFilter : boolean = false;
  @Input() asyncSearch : boolean = false;
  @Input() isLoading : boolean = false;
  // Append/pagination loader for infinite scroll. Unlike isLoading (which
  // replaces the whole list with a spinner and resets scroll to the top),
  // loadingMore shows a small spinner at the bottom while the loaded rows
  // stay mounted, so scroll position is preserved.
  @Input() loadingMore : boolean = false;
  // Name of the parent flag this picker toggles while it searches/selects.
  // Defaults to 'isLoading' (legacy single-flag behaviour). Callers that want
  // a per-dropdown scoped loader pass a dedicated flag name (e.g.
  // 'customerLoading') so one picker's spinner never lights up another's.
  @Input() loaderKey : string = 'isLoading';
  @Input() filterCount : number = 0;
  @Input('this') superObj :  CandidateVerticalFilterTemplateComponent | JobFilterVerticalTemplateComponent | CandidateFilterTemplateComponent |
  JobFilterTemplateComponent;
  @Input('filterData') filterArr : any[] = [
    {
        id : "123",
        name : "Tata",
        enabled : true
    },
    {
        id : "123",
        name : "Innova",
        enabled : false
    },
    {
        id : "123",
        name : "Hyundai",
        enabled : false
    },
    {
        id : "123",
        name : "Maruti Suzuki",
        enabled : false
    },
    {
        id : "123",
        name : "KIA",
        enabled : false
    },
    {
        id : "123",
        name : "Volkswogan",
        enabled : false
    },
    {
        id : "123",
        name : "Logan",
        enabled : false
    },
    {
        id : "123",
        name : "Avengers",
        enabled : false
    },
    {
        id : "123",
        name : "Jio",
        enabled : false
    },
  ];
  @Input() filterKey : string = '';
  @Output('onScroll') startScroll  = new EventEmitter<boolean>();
  @Output('onSearch') startSearch  = new EventEmitter<any>();
  @Output('onSelect') onSelect  = new EventEmitter<any[]>();
  searchSubject = new Subject();
  scrollSubject = new Subject();


  constructor(){}

  // ng-bootstrap accordion instance — used to programmatically collapse
  // the expanded panel on Reset. Optional because the picker can also be
  // rendered without the accordion wrapper (showFilter && withAccordion).
  @ViewChild(NgbAccordion) accordion?: NgbAccordion;

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.resetFilter && changes.resetFilter.currentValue === true){
      this.searchValue = "";
      // Also collapse the expanded panel. The accordion's expanded state
      // is internal once the user clicks the header (independent of the
      // [activeIds] input), so without this the panel stays open after
      // Reset even though the picks themselves get cleared.
      this.accordion?.collapseAll();
    }
  }

  ngOnInit(): void {
    this.subscribeSearch();
    this.subscribeScroll();
  }

  subscribeScroll() {
    this.scrollSubject.pipe(
      debounceTime(200)
    ).subscribe((e : boolean)=>{
      this.startScroll.emit(e);
    });
  }

  subscribeSearch() {
    this.searchSubject.pipe(
      debounceTime(1000)
    ).subscribe((e: string)=>{
      if(this.asyncSearch){
        (this.superObj as any)[this.loaderKey] = true;
        this.startSearch.emit(e);
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubject.unsubscribe();
    this.scrollSubject.unsubscribe();
  }


  onScrollDown(){
    this.scrollSubject.next(true);
  }

  searchValue : string = "";
  onSearch(e){
    this.searchSubject.next(e);
  }


  onChange(item){
    (this.superObj as any)[this.loaderKey] = true;
    this.onSelect.emit(this.filterArr);
  }

}
